import Register from "@/components/auth/RegisterPage.vue";
import Login from "@/components/auth/LoginPage.vue";

var authRoutes = [
    { path: '/register', component: Register , name: 'register'},
    { path: '/login', component: Login ,  name: 'login'},
  ];

export default authRoutes;